var ModalDialogInstanceService = /** @class */ (function () {
    function ModalDialogInstanceService() {
        /**
         * Used to make sure there is exactly one instance of Modal Dialog
         */
        this.componentRefs = [];
    }
    /**
     * Closes existing modal dialog
     */
    ModalDialogInstanceService.prototype.closeAnyExistingModalDialog = function () {
        while (this.componentRefs.length) {
            this.componentRefs[this.componentRefs.length - 1].destroy();
        }
    };
    /**
     * Save component ref for future comparison
     * @param componentRef
     */
    ModalDialogInstanceService.prototype.saveExistingModalDialog = function (componentRef) {
        var _this = this;
        // remove overlay from top element
        this.setOverlayForTopDialog(false);
        // add new component
        this.componentRefs = this.componentRefs.concat([componentRef]);
        componentRef.instance.showOverlay = true;
        componentRef.onDestroy(function () {
            _this.componentRefs.pop();
            _this.setOverlayForTopDialog(true);
        });
    };
    ModalDialogInstanceService.prototype.setOverlayForTopDialog = function (value) {
        if (this.componentRefs.length) {
            this.componentRefs[this.componentRefs.length - 1].instance.showOverlay = value;
        }
    };
    return ModalDialogInstanceService;
}());
export { ModalDialogInstanceService };
